import { render } from "./textmore.vue?vue&type=template&id=2fb0a69c&scoped=true"
import script from "./textmore.vue?vue&type=script&lang=js"
export * from "./textmore.vue?vue&type=script&lang=js"

import "./textmore.vue?vue&type=style&index=0&id=2fb0a69c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb0a69c"]])

export default __exports__